'use strict';

angular.module('msLegacyActivities').controller('ActivityResponseCtrl', ['$scope', 'widgetSvc', 'responseId', 'activityResponse', 'status', '$log', 'activitySvc', function ($scope, widgetSvc, responseId, activityResponse, status, $log, activitySvc) {
  var vm = this;
  $scope.isResponse = true;
  vm.responseId = responseId;
  vm.activity = activityResponse;
  vm.sharedState = status;
  // retrofit the activity to correct properties from cassandra
  vm.updateSharedState = _updateSharedState;

  // Copying scope from activityCtrl here to style activity response header
  vm.activityImageBackground = {
    'background-image': 'url(/assets/img/squaresOverlay.png), url(' + vm.activity.image + ')'
  };

  /////////////////////////////////
  /**
   * Find a Widget response, if available, for the given widget uuid.
   * @param widgetUuid - uuid of the widget to find.
   * @returns {string}
   * @private
   */
  $scope.findResponse = function (widgetUuid) {
    var widget = widgetSvc.getByUuid(vm.activity, widgetUuid);
    return !widget ? '' : widget.response;
  };
  /**
   * Update this activity response with the given shared state
   * @param activityResponse - The activity response to update
   * @param shared - The new shared state
   * @private
   */
  function _updateSharedState(shared) {
    activitySvc.updateActivityStatus(vm.responseId, shared).then(function (dat) {
      vm.sharedState = dat.data;
    });
  }
}]);